var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecn-title"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }